/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Culture_ValuesInputs */

const en_culture_values = /** @type {(inputs: Culture_ValuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Culture & Values`)
};

const de_culture_values = /** @type {(inputs: Culture_ValuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kultur & Werte`)
};

/**
* | output |
* | --- |
* | "Culture & Values" |
*
* @param {Culture_ValuesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const culture_values = /** @type {((inputs?: Culture_ValuesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Culture_ValuesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_culture_values(inputs)
	return en_culture_values(inputs)
});